import { InnerBlocks } from '@wordpress/block-editor';

export default function save( { attributes } ) {
	const {  themeDark } = attributes;
	return (
		<div
			className={
				themeDark
					? 'theme-dark wp-block-create-block-askaccordionfaq'
					: 'wp-block-create-block-askaccordionfaq'
			}
		>
			<div className="ask">
				<div className="ask-accordion">
					<div className="ask__container">
						<div className="ask__accordion__wrapper">
							<InnerBlocks.Content />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
